const types = {
    READINESS_CHECK_COMPLETE: 'READINESS_CHECK_COMPLETE',
};

const resultActions = {
    types,

    setReadinessCheckComplete(isReadinessCheckComplete) {
        return { type: types.READINESS_CHECK_COMPLETE, isReadinessCheckComplete };
    },
};

export default resultActions;
